import DashboardLayout from 'app/components/Layout/DashboardLayout';
import { Link, Navigate, RouteObject } from 'react-router-dom';
import { ReactComponent as TemplateManagement } from 'assets/icons/navs/nav-1.svg';
import { ReactComponent as AccountManagement } from 'assets/icons/navs/nav-2.svg';
import { ReactComponent as QcInspectionIcon } from 'assets/icons/navs/nav-3.svg';
import { ItemType } from 'antd/lib/menu/hooks/useItems';
import Icon from '@ant-design/icons';
import HomePage from 'app/pages/Home';
import { AuthPage } from 'app/pages/Auth';
import { SignIn } from 'app/pages/Auth/views';
import { ForgotPassword } from 'app/pages/Auth/views/ForgotPassword';
import VerifyAuth from 'app/pages/VerifyCallback';
import InspectionList from 'app/pages/Inspection/List';
import TemplateManagementPage from 'app/pages/TemplateManagment';
import { NotFoundPage } from 'app/pages/NotFound';
import JobDetail from 'app/pages/JobDetail';
import ReportDetail from 'app/pages/ReportDetail';
import BookInspection from 'app/pages/BookInspection';
import AccountManagementPage from 'app/pages/AccountManagement';
import CreatingInspector from 'app/pages/CreatingInspector';
import AccountList from 'app/pages/AccountManagement/List';
import ProtectedRoute from 'app/components/ProtectedRoute';
import React from 'react';

export const NAVS: ItemType[] = [
  {
    key: 'inspection',
    icon: <Icon style={{ fontSize: 24 }} component={QcInspectionIcon} />,
    label: <Link to={'/dashboard/inspection'}>Internal QC Inspection</Link>,
    title: 'Internal QC Inspection'
  },
  {
    key: 'account-management',
    icon: <Icon style={{ fontSize: 24 }} component={AccountManagement} />,
    label: (
      <Link to={'/dashboard/account-management'}>Inspector Management</Link>
    ),
    title: 'Inspector Management'
  },
  {
    key: 'template-management',
    icon: <Icon style={{ fontSize: 24 }} component={TemplateManagement} />,
    label: (
      <Link to={'/dashboard/template-management'}>Template Management</Link>
    ),
    title: 'Template Management'
  }
];

export const AppRoutes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage></HomePage>,
    children: [
      {
        path: 'dashboard',
        element: (
          <ProtectedRoute>
            <DashboardLayout></DashboardLayout>
          </ProtectedRoute>
        ),
        children: [
          {
            index: true,
            element: <Navigate to="/dashboard/inspection"></Navigate>
          },
          {
            path: 'inspection',
            children: [
              {
                index: true,
                element: <InspectionList></InspectionList>
              },
              {
                path: 'job/:id',
                element: <JobDetail />
              },
              {
                path: 'job/:id/report',
                element: <ReportDetail />
              },
              {
                path: 'book-inspection/:inspectionId',
                element: <BookInspection />
              }
            ]
          },
          {
            path: 'account-management',
            element: <AccountManagementPage />,
            children: [
              {
                index: true,
                element: <AccountList />
              },
              {
                path: 'inspector/:inspectorId',
                element: <CreatingInspector />
              },
              {
                path: 'creating-inspector',
                element: <CreatingInspector />
              }
            ]
          },
          {
            path: 'template-management',
            element: <TemplateManagementPage />,
            children: [
              {
                index: true,
                element: (
                  <TemplateManagementPage.Index></TemplateManagementPage.Index>
                )
              },
              {
                path: 'template',
                element: (
                  <TemplateManagementPage.Information></TemplateManagementPage.Information>
                )
              },
              {
                path: 'template/:id',
                element: (
                  <TemplateManagementPage.Information></TemplateManagementPage.Information>
                )
              }
            ]
          }
        ]
      }
    ]
  },
  {
    path: '/sign-in',
    element: <AuthPage />,
    children: [
      {
        index: true,
        element: <SignIn></SignIn>
      }
    ]
  },
  {
    path: '/reset-password',
    element: <AuthPage />,
    children: [
      {
        index: true,
        element: <ForgotPassword></ForgotPassword>
      }
    ]
  },
  {
    path: '/callback',
    children: [
      {
        index: true,
        element: <VerifyAuth />
      }
    ]
  },
  {
    path: '*',
    element: <NotFoundPage></NotFoundPage>
  }
];

export const getCurrentNav = () => {
  const pathName = window.location.pathname;
  const currentPath = pathName.replace(/\/(dashboard)/, '').split('/');

  const currentNav = NAVS.find((nav) =>
    currentPath.includes(nav.key as string)
  );

  return currentNav as {
    icon: React.ReactNode;
    label: React.ReactNode;
    title: React.ReactNode;
  };
};
